<template>
  <v-flex xs12 class="allNotesCard__container-item mb-2" :id="note.date">
    <v-card color="" class="white--text noteItem">
      <v-toolbar color="accent" dark window class="allNotesCard__container-item__toolbarTitle" >
        <v-toolbar-title >
          <div class="toolbarTitle__name" :ref="note.date">{{ note.rusDate }}</div>
          <v-spacer />
          <v-progress-circular class="allNotesCard__container-item__loader mr-3" v-show="onChanging" indeterminate/>
          <v-tooltip top>
            <v-icon @click="showOnCalendar" slot="activator">mdi-calendar-search</v-icon>
            <span>Отобразить на календаре</span>
          </v-tooltip>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title primary-title :class="`noteContent noteContentItem-${note.date} ${note.text.length===0 ? '-fakeNote' : '' }`">
        <div @click="switchEditor" v-if="!editorOn" v-html="note.text" class="noteContent__card mce-content-body" :id="`noteContent__card-${note.date}`"></div>
          <v-slide-y-transition>
            <NotesEditor v-if="editorOn" 
              :editorHeight="editorHeight" 
              :editorText="note.text"
              :noteObj="note"
            />
          </v-slide-y-transition>
      </v-card-title>
    </v-card>
  </v-flex>
</template>
<script>
import NotesEditor from './NotesEditor'
import { throttle, debounce } from 'lodash';
import '@/../static/disc/tinymce.css';

export default {
  name: 'Note',
  props: {
    noteItem: {
      type: Object,
      required: true
    },
    todayDate: {
      type: String
    }
  },
  components: {
    NotesEditor
  },
  data() {
    return {
      editorOn: false,
      editorHeight: null,
      throttleDelay: 3000,
      note: this.noteItem,
      today: this.todayDate,
      showEditorTools: false,
      toolbarHeight: 34,
      editorReady: false,
      allowSaveContent: false,
      onChanging: false,
    };
  },
  methods: {
    switchEditor() {
      this.editorOn = true
    },
    showOnCalendar() {
      this.$bus.$emit('showOnCalendar', this.note.date)
    },
    convertDateToRusFormat(date) {
      return moment(date).format('DD MMM, dddd YYYY ') + 'г.';
    }
  },

  created() {
    this.note.rusDate = this.convertDateToRusFormat(this.note.date);
  },
  mounted() {
    let _editorArea = `noteContent__card-${this.note.date}`
    let _editorTarget = document.getElementById(_editorArea)
    this.editorHeight = _editorTarget.clientHeight
  }
};

</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/apps/bpm/notes/components/notes/Note.vue